<template>
  <v-container class="cmp-settings-users-user_sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details">
      <div class="dt-details--header">
        <span
              v-if="selectedUserDetails && selectedUserDetails.ext_user"
              >{{$t('external_user_permission_for')}} {{
                selectedUserDetails.ext_user.given_name || $t('user_name')
              }}</span  >
      </div>
      </div>
</div>
      <glayout
        :tabs="[
        {
          route: 'overview',
          value: $t('overview'),
        }]"
        :showTabs="false"
        :loading="externalUserDetails && externalUserDetails.loading"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedUserDetails &&
                      selectedUserDetails.royalty_accounts &&
                      selectedUserDetails.royalty_accounts.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('external_access_royalty')"
              >
                <ExternalUserAccess
                  @externalUserPermissionDelete="onExternalUserPermissionDelete"
                  :selectedUserDetails="selectedUserDetails"
                  @add_click="onAddExternalUserPermissionModal"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>
    <!-- Sidewindow -->

    <ModalContainer
      :modalKey="'addPermissionExternalUser'"
      :width="'medium'"
      @cancelled="onHideComponentModal"
    >
      <AddPermissionExternalUser
        @cancelled="onHideComponentModal"
        @added="onAddExternalPermission"
      />
    </ModalContainer>
  </v-container>
</template>
<script>
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import * as ActionTypes from "../../store/types";
import { SettingsStoreNamespace as storeNS } from "../../store";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
import UserDetails from "./user-details";
import { mapGetters } from "vuex";

import General from "./general";
import HideModule from "./hide-module";
import { mapKeyToAction } from "../../../../store/global";
import DList from "@dtplugins/list/dlist";
import DBox from "@dtplugins/dbox/dbox";
import {
  createModalMixin,
  openModalRoute,
  closeModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
import HideInvoices from "./hide-invoices";
import HideArtistsFees from "./hide-artists-fees.vue";
import ExternalUserAccess from "./external-user-access.vue";
import AddPermissionExternalUser from "./add-permission-external-user.vue";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";

export default {
  components: {
    UserDetails,
    DList,
    DBox,
    General,
    HideModule,
    HideInvoices,
    HideArtistsFees,
    ModalContainer,
    ExternalUserAccess,
    AddPermissionExternalUser,
  },
  data: function () {
    return {
      isExternalUserList: false,
    };
  },
  mixins: [createDTGridHost(), createModalMixin("addPermissionExternalUser")],
  computed: {
    ...mapGetters(storeNS, {
      externalUserDetailsArray: "externalUserDetails",
    }),
    external_user_id: function () {
      return this.$route.params.external_user_id;
    },
    selectedUserDetails: function () {
      console.log("this.externalUserDetails", this.externalUserDetails);
      const royalty_accounts =
        this.externalUserDetails?.royalty_accounts?.filter(
          (r) => r.external_user_id == this.external_user_id
        ) || [];

      return {
        ...this.externalUserDetails,
        royalty_accounts,
      };
    },
    externalUserDetails: function() {
      const defaultValues = {};
      const selectedUserDetails =  (this.externalUserDetailsArray || [])[this.external_user_id] || defaultValues;
      return selectedUserDetails;
    },
  },

  methods: {
    ...mapKeyToAction(storeNS, [
      ActionTypes.SelectedUser.UPDATE.SINGLE,
      ActionTypes.HIDE_USER_MODULE,
      ActionTypes.RoyaltyAccounts.SET.ALL,
      ActionTypes.RoyaltyAccounts.DELETE.SINGLE,
      ActionTypes.UPDATE_USER_DETAILS,
      ActionTypes.DELETE_HIDDEN_INVOICE_PROJECT,
      ActionTypes.DELETE_HIDDEN_ARTISTS_FEES,
    ]),
    onExternalUserPermissionDelete: async function (item) {
      const { external_users_permission_id } = item;
      const confirmationResult = await confirmDelete(
        "Permission",
        item.royalty_account_name
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.RoyaltyAccounts.DELETE.SINGLE](
          external_users_permission_id
        );
      }
    },
    onCloseUserDetailsClick: function () {
      this.$emit("closed", true);
    },
    onUserChange: function (payload) {
      if (!this.userDetails?.uid) {
        return;
      }
      this[ActionTypes.SelectedUser.UPDATE.SINGLE](payload);
    },
    onUserModuleChange: async function (payload) {
      this[ActionTypes.HIDE_USER_MODULE](payload);
      await NotificationService.showNotification({
        text: this.$t("user_details_saved"),
      });
    },
    onAddExternalPermission: function (e) {
      this[ActionTypes.RoyaltyAccounts.SET.ALL](e);
      openModalRoute(this, "hide_invoices");
    },
    onAddExternalUserPermissionModal: function (e) {
      openModalRoute(this, "add_permission_external_user");
    },
    onAddFeesForArtists: function () {
      console.log("onAddFeesForArtists");
      openModalRoute(this, "hide_artists_fees");
    },
    onHideComponentModal: function () {
      closeModalRoute(this);
    },
    onInvoiceProjectHide: function (payload) {
      this.onHideComponentModal();

      this[ActionTypes.UPDATE_USER_DETAILS]({
        name: "invoice_projects",
        value: payload,
      });
    },
    onInvoiceUnhide: function (item) {
      console.log(item);
      this[ActionTypes.DELETE_HIDDEN_INVOICE_PROJECT]({
        invoice_project_id: item.invoice_project_id,
        user_id: this.userDetails.usr.user_id,
      });
    },
    onArtistUnhide: function (item) {
      this[ActionTypes.DELETE_HIDDEN_ARTISTS_FEES]({
        artist_id: item.artist_id,
        user_id: this.userDetails.usr.user_id,
      });
    },
    onArtistsFeesHide: function (payload) {
      this.onHideComponentModal();

      this[ActionTypes.UPDATE_USER_DETAILS]({
        name: "artists",
        value: payload,
      });
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-settings-users-user_sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 81px);
  }

  .variable-table {
    width: 100%;
    padding: 5px;
    th {
      text-align: left;
    }
    tbody {
      td:first-child {
        // font-weight: 600;
      }
    }
    tr {
      height: 25px;
    }
  }

  .html-editor-container {
    height: 310px;
    overflow: auto;
    .ck-content {
      height: 270px;
    }
  }
}
</style>
